import { CommentFilters as CommentFilters } from "@/services/comments";
import { PostListFilter } from "@/services/posts";
import { SocialMediaUserFilter } from "@/services/user";

type Filters = CommentFilters & SocialMediaUserFilter & PostListFilter;

export const getFilterQueryParams = (filters: Filters) => {
  const params = new URLSearchParams();
  if (filters.visibilities) params.set("vb", (filters.visibilities || []).join(","));
  if (filters.attributes) params.set("ab", (filters.attributes || []).join(","));
  if (filters.tags) params.set("tg", (filters.tags || []).join(","));
  if (filters.text) params.set("se", (filters.text || []).join(","));
  if (filters.sort) params.set("sort", filters.sort);
  if (filters.unsafe) params.set("unsafe", filters.unsafe.toString());
  if (filters.order) params.set("order", filters.order);
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  if (filters.statusFilter) params.set("stf", filters.statusFilter);
  if (filters.statuses) params.set("st", (filters.statuses || []).join(","));
  if (filters.blockStates) params.set("bs", (filters.blockStates || []).join(","));
  if (filters.commentCount) params.set("commentCount", filters.commentCount);
  if (filters.smuName) params.set("smu", filters.smuName);
  if (filters.watchlist) params.set("wl", filters.watchlist);
  if (filters.watchlistType) params.set("wl-type", filters.watchlistType);
  if (filters.post) params.set("post", filters.post);
  if (filters.statusConnection) params.set("st-connection", filters.statusConnection);
  const url = `?${params}`;
  return url;
};
